
    import { useVuelidate } from '@vuelidate/core'
    import { required, email, helpers, minLength, maxLength } from '@vuelidate/validators'

    import { defineComponent } from 'vue';

    import GetLanguage from '@/tools/language';
    import GeneralFx from '@/tools/general_fx';
    import { SalesRefundEntryStock } from '@/models/salestypes';
    import { ManagtUser } from '@/models/managttypes';
    import AppDeclarations from '@/tools/declarations';

    const language =GetLanguage(),
        appFxs = GeneralFx();
    const greaterThanZero = (val: number) => val > 0;
    const fNewDate = new Date(),
        year = fNewDate.getFullYear()

    const emptyDeliverOper:SalesRefundEntryStock = {
        IdRefundEntry: 0,
        RefundEntryKey: '',
        RefundKey: '',
        RefundNbr: '',
        RefundEntryNbr: '',
        RefundEntryStatus: 0,
        OrderNbr: '',
        OrderKey: '',
        RefundEntryDate: fNewDate,
        UserEmail: '',
        Barcode: '',
        QrCode: '',
        ReceiverName: '',
        ReceiverTel: '',
        CreatedBy: '',
    }


    export default defineComponent({        
        name: 'RefundEntryStockModal',
        emits: ['closeForm'],
        props: [
            "visible",
            "initialValues", 
            "recordStatus",
            "listOfUsers",
        ],
        data(){
            return  {
                v$: useVuelidate(),
                appFxs,
                language,
                dataRecord: {...emptyDeliverOper} as SalesRefundEntryStock,
                isSavingRecord: false,
                currCode: 'RWF',

                theListStaff: [] as ManagtUser[],

                userEmail: '',
            }
        },
        computed: {
            windowTitle() {
                return this.recordStatus == 0 ? language.add_ref_stock :
                    language.edit_ref_stock;
            },
        },
        methods: {
            generateOrderNbr(){
                this.dataRecord.RefundEntryNbr =  appFxs.generateRefEntrStockOperNbr();
            },
            closeFormRet(){
                this.$emit('closeForm', {returnType: 0, returnData: null});
            },
            selectOnFocus(evt: Event){
                const oInput = evt.target as HTMLInputElement;
                oInput.select();
            },
            saveRecordData(){
                this.$emit('closeForm', {returnType: 1, returnData: this.dataRecord});
            },
        },
        watch:{
            visible: {
                handler(newV, oldV){
                    if((newV) && newV !== oldV ){
                        const oValues = appFxs.getProxyData(this.initialValues);
                        const fValues: SalesRefundEntryStock = {
                            ...oValues, RefundEntryDate: new Date(oValues.RefundEntryDate)
                        } as SalesRefundEntryStock;

                        const userEmail = appFxs.getLocalStorageByKey(AppDeclarations.userEmail, '');
                        this.userEmail = userEmail;

                        this.theListStaff = appFxs.getProxyData(this.listOfUsers) as ManagtUser[];
                        this.v$.$reset();
                        this.dataRecord = fValues;
                    }
                }
            }
        },
        validations(){
            return {
                dataRecord: {
                    RefundEntryKey: {
                        required: helpers.withMessage(language.fldRequired, required),                 
                        $autoDirty: true,
                    },
                    RefundEntryNbr: {
                        required: helpers.withMessage(language.fldRequired, required),                 
                        $autoDirty: true,
                    },
                    RefundNbr: {
                        required: helpers.withMessage(language.fldRequired, required),                 
                        $autoDirty: true,
                    },
                    RefundKey: {
                        required: helpers.withMessage(language.fldRequired, required),                 
                        $autoDirty: true,
                    },
                    OrderKey: {
                        required: helpers.withMessage(language.fldRequired, required),                 
                        $autoDirty: true,
                    },
                    OrderNbr: {
                        required: helpers.withMessage(language.fldRequired, required),                 
                        $autoDirty: true,
                    },
                    UserEmail: {
                        required: helpers.withMessage(language.fldRequired, required),                 
                        $autoDirty: true,
                    },
                    Barcode: {
                        required: helpers.withMessage(language.fldRequired, required),                 
                        $autoDirty: true,
                    },
                    QrCode: {
                        required: helpers.withMessage(language.fldRequired, required),                 
                        $autoDirty: true,
                    },
                    CreatedBy: {
                        required: helpers.withMessage(language.fldRequired, required),                 
                        $autoDirty: true,
                    },
                }
            }
        },
        mounted(){
            appFxs.updateLoadedScripts();
        }
    })
